import apiClient from '../utils/axiosClient';

export const loadCurrentUser = async () => {
  return (await apiClient.get('/user/current'))?.data;
};

export const loadUserSettings = async (): Promise<{
  urls: {
    appointments?: string;
    operations?: string;
    performanceTracker?: string;
  }
}> => {
  return (await apiClient.get('/user/get-user-settings'))?.data;
};
